class HeaderV3 {
  constructor($module) {
    this.$module = $module
    this.$navRow = $module.querySelector('.hse-header-v3__nav-row')
    this.$menuButton = $module.querySelector('.hse-header-v3__menu-button')
    this.$menu = $module.querySelector('.hse-header-v3__menu')
    this.$menuNav = $module.querySelector('.hse-header-v3__menu-nav')
    this.$barItems = Array.from(
      $module.querySelectorAll('.hse-header-v3__primary-item')
    )
    this.$menuItems = Array.from(
      $module.querySelectorAll('.hse-header-v3__menu-primary-item')
    )
  }

  init() {
    if (!this.$navRow || !this.$menuButton || !this.$menu) {
      return
    }

    // Without JavaScript the Menu button is hidden and the menu is open. The
    // enhanced class switches the bar from wrapping to priority links.
    this.$module.classList.add('hse-header-v3--enhanced')
    this.$menuButton.hidden = false
    this.setMenuOpen(false)

    this.$menuButton.addEventListener('click', () => {
      this.setMenuOpen(!this.isMenuOpen())
    })

    this.$module.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isMenuOpen()) {
        this.setMenuOpen(false)
        this.$menuButton.focus()
      }
    })

    this.updatePriorityLinks()

    if (typeof window.ResizeObserver === 'function') {
      new window.ResizeObserver(() => this.updatePriorityLinks()).observe(
        this.$navRow
      )
    } else {
      window.addEventListener('resize', () => this.updatePriorityLinks())
    }
  }

  isMenuOpen() {
    return this.$menuButton.getAttribute('aria-expanded') === 'true'
  }

  setMenuOpen(open) {
    this.$menuButton.setAttribute('aria-expanded', String(open))
    this.$menu.hidden = !open
  }

  // The Menu button is hidden by CSS from the large-desktop breakpoint, so
  // its visibility tells us which layout is active without repeating the
  // breakpoint here.
  isDesktop() {
    return window.getComputedStyle(this.$menuButton).display === 'none'
  }

  // Priority links (NHS.UK header pattern): keep links in the bar, in order,
  // until the next one doesn't fit beside the Menu button; the rest show in
  // the menu panel instead.
  updatePriorityLinks() {
    this.$barItems.forEach(($item) => {
      $item.hidden = false
    })

    let visibleCount = this.$barItems.length

    if (this.isDesktop()) {
      if (this.isMenuOpen()) {
        this.setMenuOpen(false)
      }
    } else {
      const buttonStyle = window.getComputedStyle(this.$menuButton)
      const available =
        this.$navRow.clientWidth -
        this.$menuButton.offsetWidth -
        (parseFloat(buttonStyle.marginLeft) || 0)

      let used = 0
      const firstOverflowing = this.$barItems.findIndex(($item) => {
        used += $item.offsetWidth
        return used > available
      })

      if (firstOverflowing !== -1) {
        visibleCount = firstOverflowing
      }

      this.$barItems.forEach(($item, index) => {
        $item.hidden = index >= visibleCount
      })
    }

    this.$menuItems.forEach(($item, index) => {
      $item.hidden = index < visibleCount
    })

    if (this.$menuNav) {
      this.$menuNav.hidden = visibleCount === this.$menuItems.length
    }
  }
}

module.exports = ({ scope = document } = {}) => {
  const headers = scope.querySelectorAll('[data-module="hse-header-v3"]')
  headers.forEach(($module) => {
    // initAll(scope) can run again over content it has already seen - a
    // second instance would bind every listener twice.
    if ($module.dataset.headerV3Initialised) {
      return
    }
    $module.dataset.headerV3Initialised = 'true'
    new HeaderV3($module).init()
  })
}

module.exports.HeaderV3 = HeaderV3
